export const SET_CSRF_TOKEN = 'form/SET_CSRF_TOKEN';
export const types = {
  SET_CSRF_TOKEN
};
export const initialState = {
  enabled: false
};
export function csrfReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CSRF_TOKEN:
      return {
        ...state,
        token: action.token,
        enabled: true
      };
    default:
      return state;
  }
}